import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategorise } from '../../../../../mechanics/rid-categorise/rid-categorise';

@Component({
  selector: 'app-categorise-word-to-rule-page',
  imports: [RidCategorise],
  templateUrl: './categorise-word-to-rule-page.html',
})
export class CategoriseWordToRulePage {
  protected readonly $router = inject(Router);
}
